import { twMerge } from "tailwind-merge";
import { toFarsiNumber } from "@utils/digits";
import MenuDotsIcon from "@svg/new-design/menu-dots";
import { paginationButonClass } from "./constants";
import { PAGINATION_BUTTON_VARIANT, PaginationItemProps } from "./types";
import { FC } from "react";

const itemsClassName =
  "px-2 flex items-center justify-center rounded-md bg-white text-fds-primary body-sm fds-sm:body-md ml-1";

const PaginationItem: FC<PaginationItemProps> = ({
  page,
  isCurrent,
  isLast,
  onClick,
  dots,
}) => {
  if (dots)
    return (
      <button
        className={twMerge(
          itemsClassName,
          paginationButonClass[PAGINATION_BUTTON_VARIANT.ARROW].class
        )}
      >
        <MenuDotsIcon />
      </button>
    );

  return (
    <button
      className={twMerge(
        itemsClassName,
        isCurrent &&
          "bg-fds-brand-light border-transparent !text-fds-brand cursor-default",
        isLast && "ml-0",
        paginationButonClass[PAGINATION_BUTTON_VARIANT.ARROW].class
      )}
      onClick={onClick}
    >
      {toFarsiNumber(page!)}
    </button>
  );
};

export default PaginationItem;
